export type PushSubscriptionUnsubs = {
  fcm?: () => void;
  voip?: () => void;
};

function safeUnsub(fn?: () => void): void {
  try {
    fn?.();
  } catch {
    /* noop */
  }
}

/**
 * Registers FCM then VoIP push hooks. If {@code signal} aborts between awaits,
 * any subscription already obtained is torn down so listeners do not leak.
 */
export async function loadAuthPushSubscriptions(
  signal: AbortSignal,
  deps: {
    syncFcmTokenToBackend: () => Promise<() => void>;
    setupIosVoipPush: () => Promise<() => void>;
  },
): Promise<PushSubscriptionUnsubs> {
  const out: PushSubscriptionUnsubs = {};
  try {
    const fcm = await deps.syncFcmTokenToBackend();
    if (signal.aborted) {
      safeUnsub(fcm);
      return {};
    }
    out.fcm = fcm;
  } catch (e) {
    console.warn('[AuthContext] FCM token sync failed', e);
  }
  try {
    const voip = await deps.setupIosVoipPush();
    if (signal.aborted) {
      safeUnsub(out.fcm);
      safeUnsub(voip);
      return {};
    }
    out.voip = voip;
  } catch (e) {
    safeUnsub(out.fcm);
    console.warn('[AuthContext] iOS VoIP push setup failed', e);
  }
  if (signal.aborted) {
    teardownPushSubscriptions(out);
    return {};
  }
  return out;
}

export function teardownPushSubscriptions(u: PushSubscriptionUnsubs): void {
  safeUnsub(u.fcm);
  safeUnsub(u.voip);
}
